import Content from '../components/Contact/Content';

const Contact = () => {
  return (
    <div>
      <Content />
    </div>
  );
};

export default Contact;
